import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { increaseQuantity, decreaseQuantity, deleteItem } from '../../store/actions/cartActions/cartActions';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import jsPDF autotable plugin.

import './Cart.css';

const Cart = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const navigate = useNavigate();

  // State for shipping address
  const [shippingAddress, setShippingAddress] = useState({
    name: '',
    doorNumber: '',
    street: '',
    taluk: '',
    district: '',
    state: '',
    postalCode: '',
    mobileNumber: ''
  });

  const handleIncreaseQuantity = (cartItemId) => {
    dispatch(increaseQuantity(cartItemId));
  };

  const handleDecreaseQuantity = (cartItemId) => {
    dispatch(decreaseQuantity(cartItemId));
  };

  const handleDeleteItem = (cartItemId) => {
    dispatch(deleteItem(cartItemId));
  };

  const handleContinueShopping = () => {
    navigate('/');
  };

  // Function to generate PDF billing with business details
  const generatePDF = () => {
    const doc = new jsPDF();
  
    // Main Header: Aurora Fireworks
    doc.setFontSize(22);
    doc.text('Aurora Fireworks', 105, 20, null, null, 'center'); // Centered
  
    // Subheader: WhatsApp Payment Instruction (smaller than header)
    doc.setFontSize(12);
    const whatsappInstruction = "Send this pdf quotation and paid screenshot to our WhatsApp number: 9597624265";
    doc.text(whatsappInstruction, 105, 30, null, null, 'center'); // Centered below the main header
  
    // Quotation Title
    doc.setFontSize(18);
    doc.text('Quotation', 14, 50);
  
    // Shipping Address
    doc.setFontSize(12);
    doc.text('Shipping Address:', 14, 60);
    doc.text(`Name: ${shippingAddress.name}`, 14, 66);
    doc.text(`Door Number: ${shippingAddress.doorNumber}`, 14, 72);
    doc.text(`Street: ${shippingAddress.street}`, 14, 78);
    doc.text(`Taluk: ${shippingAddress.taluk}`, 14, 84);
    doc.text(`District: ${shippingAddress.district}`, 14, 90);
    doc.text(`State: ${shippingAddress.state}`, 14, 96);
    doc.text(`Postal Code: ${shippingAddress.postalCode}`, 14, 102);
    doc.text(`Mobile Number: ${shippingAddress.mobileNumber}`, 14, 108);
  
    // Table for Cart Items
    const tableColumn = ['Item Name', 'Rs / Item', 'Quantity', 'Total Price'];
    const tableRows = [];
  
    cartItems.forEach(item => {
      const itemData = [
        item.item_name,
        `Rs ${item.after_discount}`,
        item.quantity,
        `Rs ${item.quantity * item.after_discount}`
      ];
      tableRows.push(itemData);
    });
  
    // Generate the table using autoTable
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 120, // Adjust starting position to leave space for header and instructions
    });
  
    // Total Items and Total Amount
    const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);
    const totalAmount = cartItems.reduce((total, item) => total + item.quantity * item.after_discount, 0);
  
    // Display totals below the table
    doc.text(`Total Items: ${totalItems}`, 14, doc.previousAutoTable.finalY + 10);
    doc.text(`Total Amount: Rs ${totalAmount}`, 14, doc.previousAutoTable.finalY + 16);
  
    // Footer Content
    // Footer Content: Positioned slightly above the bottom margin
const footerText = "It's the responsibility of the customer to collect from the nearest registered transport service. We will inform you on time.";
doc.setFontSize(10);  // Reduce font size for the footer to fit within margins
const pageHeight = doc.internal.pageSize.height;  // Get the page height

// Position footer 10 units above the bottom of the page
doc.text(footerText, 105, pageHeight - 10, null, null, 'center');  // Footer content centered near the bottom

   
    doc.save('invoice.pdf');
  };
  
  
  



  // const handleCheckout = () => {
  //   const totalAmount = cartItems.reduce((total, item) => total + item.quantity * item.after_discount, 0);
    
  //   if (totalAmount < 3000) {
  //     alert('Minimum order amount is ₹3000 to proceed');
  //   } else if (Object.values(shippingAddress).some(field => field === '')) {
  //     alert('Please fill in all shipping details');
  //   } else {
  //     alert('Send this pdf quotation and paid screenshot to our WhatsApp number to confirm, உறுதிப்படுத்த இந்த pdf மற்றும் பணம் செலுத்திய ஸ்கிரீன்ஷாட்டை எங்கள் வாட்ஸ்அப் எண்ணுக்கு அனுப்பவும்');
  //     generatePDF(); // Generate PDF on checkout
  //     navigate('/payment');
  //   }
  // };
  

  const handleCheckout = () => {
  const totalAmount = cartItems.reduce(
    (total, item) =>
      total + item.quantity * item.after_discount,
    0
  );

  if (totalAmount < 3000) {
    alert("Minimum order amount is ₹3000 to proceed");
    return;
  }

  if (Object.values(shippingAddress).some((field) => field === "")) {
    alert("Please fill in all shipping details");
    return;
  }
        alert('Send this pdf quotation and paid screenshot to our WhatsApp number to confirm. உறுதிப்படுத்த இந்த pdf மற்றும் பணம் செலுத்திய ஸ்கிரீன்ஷாட்டை எங்கள் வாட்ஸ்அப் எண்ணுக்கு அனுப்பவும்');

  // Generate PDF quotation
  generatePDF();

  // Prepare each ordered item
  const itemDetails = cartItems
    .map(
      (item, index) =>
        // `${index + 1}. ${item.name || item.product_name || item.title || "Product"}
      `${index + 1}. ${item.item_name}
Qty: ${item.quantity}
Price: ₹${Number(item.after_discount || 0).toFixed(2)}
Amount: ₹${(
          item.quantity * Number(item.after_discount || 0)
        ).toFixed(2)}`
    )
    .join("\n\n");

  // WhatsApp message
  const message = `🎆 NEW ORDER - AURORA FIRE WORKS 🎆

Hello Aurora Fire Works,

I would like to confirm my order.

👤 CUSTOMER DETAILS
Name: ${shippingAddress.name}
Mobile: ${shippingAddress.mobileNumber}

📍 DELIVERY ADDRESS
Door No: ${shippingAddress.doorNumber}
Street: ${shippingAddress.street}
Taluk: ${shippingAddress.taluk}
District: ${shippingAddress.district}
State: ${shippingAddress.state}
Postal Code: ${shippingAddress.postalCode}

🛒 ORDER DETAILS

${itemDetails}

💰 TOTAL ORDER AMOUNT: ₹${totalAmount.toFixed(2)}

📄 Quotation PDF has been generated.

I will send the payment screenshot along with the quotation PDF for order confirmation.

Thank you!
Aurora Fire Works ✨`;

  // Open WhatsApp
  const whatsappUrl = `https://wa.me/919597624265?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");

  // Navigate to payment
  navigate("/payment");
        alert('Send this pdf quotation and paid screenshot to our WhatsApp number to confirm, உறுதிப்படுத்த இந்த pdf மற்றும் பணம் செலுத்திய ஸ்கிரீன்ஷாட்டை எங்கள் வாட்ஸ்அப் எண்ணுக்கு அனுப்பவும்');

};

 


  // Handle changes in shipping address form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <div className="cart-container">
      <h3>Shopping Cart</h3>
      {cartItems.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <div className="cart-table-container">
          <table className="cart-table">
            <thead>
              <tr>
                <th>Items</th>
                <th>₹/Item</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => (
                <tr key={item.cartItemId}>
                  <td>{item.item_name}</td>
                  <td>₹{item.after_discount}</td>
                  <td>
                    <button className="quantity-btn" onClick={() => handleDecreaseQuantity(item.cartItemId)}>-</button>
                    <span>{item.quantity}</span>
                    <button className="quantity-btn" onClick={() => handleIncreaseQuantity(item.cartItemId)}>+</button>
                  </td>
                  <td>₹{item.quantity * item.after_discount}</td>
                  <td>
                    <button className="delete-btn" onClick={() => handleDeleteItem(item.cartItemId)}>X</button>
                  </td>
                </tr>     
              ))}
            </tbody>
          </table>
          
          <div className="cart-total">
            <p><strong>Total Items:</strong> {cartItems.reduce((total, item) => total + item.quantity, 0)}</p>
            <p><strong>Total Amount:</strong> ₹{cartItems.reduce((total, item) => total + item.quantity * item.after_discount, 0)}</p>
          </div>
        </div>
      )}

      {/* Shipping Address Form */}
      <div className="shipping-address">
        <h4>Shipping Address</h4>
        <form>
          <label>
            Name:
            <input type="text" name="name" value={shippingAddress.name} onChange={handleChange} />
          </label>
          <label>
            Door Number:
            <input type="text" name="doorNumber" value={shippingAddress.doorNumber} onChange={handleChange} />
          </label>
          <label>
            Street:
            <input type="text" name="street" value={shippingAddress.street} onChange={handleChange} />
          </label>
          <label>
            Taluk:
            <input type="text" name="taluk" value={shippingAddress.taluk} onChange={handleChange} />
          </label>
          <label>
            District:
            <input type="text" name="district" value={shippingAddress.district} onChange={handleChange} />
          </label>
          <label>
            State:
            <input type="text" name="state" value={shippingAddress.state} onChange={handleChange} />
          </label>
          <label>
            Postal Code:
            <input type="number" name="postalCode" value={shippingAddress.postalCode} onChange={handleChange} />
          </label>
          <label>
            Mobile Number:
            <input type="number" name="mobileNumber" value={shippingAddress.mobileNumber} onChange={handleChange} />
          </label>
        </form>
        <div className="cart-buttons">
          <button className="button-checkout" onClick={handleCheckout}>Confirm Order</button>
          <button className="button-continue-shopping" onClick={handleContinueShopping}>Shop More</button>
        </div>
      </div>
    </div>
  );
};

export default Cart;



























